import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitCreateDealflow } from 'components/views/InvestorDealflow/_helpers/investorDealflow.events';
import { $view } from 'signals/global.signals';
import InvestorDealForm from 'components/global/InvestorDealForm';

const InvestorCreateDealFlowModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'investor-dealflow-create'}
    title="Add Opportunity"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitCreateDealflow}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <InvestorDealForm />
  </SimpleModal>

);

export default InvestorCreateDealFlowModal;
